import { render, staticRenderFns } from "./ShowRelationsModal.vue?vue&type=template&id=1f31438f&"
import script from "./ShowRelationsModal.vue?vue&type=script&lang=js&"
export * from "./ShowRelationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports